import { render, staticRenderFns } from "./MyWallet.vue?vue&type=template&id=4bf57968&scoped=true&"
import script from "./MyWallet.vue?vue&type=script&lang=ts&"
export * from "./MyWallet.vue?vue&type=script&lang=ts&"
import style0 from "./MyWallet.vue?vue&type=style&index=0&id=4bf57968&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf57968",
  null
  
)

export default component.exports